"use client";

import { ErrorMessage } from "@hookform/error-message";
import type { ComponentProps } from "react";
import { useFormContext } from "react-hook-form";
import { Alert } from "../../../..";

interface RadioGroupRootProps extends ComponentProps<"div"> {
	name: string;
}

export function NativeRadioGroupRoot(props: RadioGroupRootProps) {
	const { name, children, ...restProps } = props;

	const methods = useFormContext();
	const invalid = name ? methods?.getFieldState(name)?.invalid : false;

	return (
		<div {...restProps}>
			{children}

			{invalid && (
				<Alert variant="warning">
					<ErrorMessage name={name} />
				</Alert>
			)}
		</div>
	);
}
